import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth as useClerkAuth } from '@clerk/clerk-react';

/**
 * /signout — nuclear sign-out route.
 * Clears all local storage, signs out of Clerk, redirects to /login.
 * Navigate here instead of calling logout() directly when session
 * rebuilding is suspected.
 */
export default function SignOutScreen() {
  const { signOut } = useClerkAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const doSignOut = async () => {
      try {
        localStorage.clear();
        sessionStorage.clear();
        await signOut();
      } catch (_) {
        // Ignore — proceed to login regardless
      } finally {
        navigate('/login', { replace: true });
      }
    };
    doSignOut();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      background: '#001a4d',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: "'Oswald', sans-serif",
      fontSize: '14px',
      letterSpacing: '3px',
      color: 'rgba(255,255,255,0.4)',
      textTransform: 'uppercase',
    }}>
      Signing out…
    </div>
  );
}
